<template>
    <div class="icon-row-cell-wrapper" style="pointer-events: none" :class="value ? value.classes : null">
		<component v-if="value" :is="iconSvgComponent" class="cell-icon"></component>
    </div>
</template>

<script setup>
/* Vue */
import { computed, defineAsyncComponent } from 'vue'

/* Emmitters */
const emit = defineEmits(['closeRowClicked'])

/** Props received:
@value {String} icon name to display
or
@value {Object} when we need classes or masks, object with:
	icon {String} icon name to display
	classes {String} classes that will be added to component
*/
const props = defineProps({
	value: [String, Object]
})

const iconSvgComponent = computed(() => {
	const iconName = props.value.icon ? props.value.icon : props.value
	return defineAsyncComponent(() => import('@/assets/icons/' + iconName + '.svg?inline'))
})
</script>

<style lang="scss" scoped>
.icon-row-cell-wrapper {
	width: auto;
    height: 100%;

	display: flex;
	align-items: center;
	justify-content: center;

    .cell-icon {
		width: 16px;
		height: 16px;
        flex-shrink: 0;
	}
}
</style>
